import {ShapeCommand} from '../commands.template';
export class TextCreateCommand extends ShapeCommand {
  protected services: any;

  constructor(data) {
    super(data);
  }

  public execute() {
    super.execute();

    const graph = this.services.editorRegistrySvc.getGraph();
    const cell = this.services.shapeSpawnerSvc.createText(this.object);

    graph.addCell(cell, this.services.graphHelperSvc.textParent());

    this.object.mxKey = Number(cell.id);
    this.executeJson(this.object);

    return cell;
  }

  public reverse() {
    super.reverse();

    const graph = this.services.editorRegistrySvc.getGraph();

    const cell = this.services.graphHelperSvc
      .allTexts()
      .find(tCell => Number(tCell.id) === Number(this.object.mxKey));

    graph.removeCells([cell], false);

    return this.reverseJson(this.object);
  }

  private reverseJson(data) {
    return this.services.diagramUpdateSvc.update({
      deleteText: {
        mxKey: Number(data.mxKey)
      }
    });
  }

  private executeJson(data) {
    return this.services.diagramUpdateSvc.update({
      createText: {
        mxKey: Number(data.mxKey),
        number: Number(data.number),
        text: data.text,
        customStyle: data.customStyle,
        style: data.style,
        position: {x: data.position.x, y: data.position.y, w: data.position.w, h: data.position.h},
        link: data.link
      }
    });
  }
}
